import {
  CATEGORICAL_SCALE_TYPE,
  LOG_SCALE_TYPE,
  NUMERICAL_SCALE_TYPE,
  TIME_SCALE_TYPE,
} from './xy-chart.js';

export type NUMERICAL = 'numerical';
export const NUMERICAL: NUMERICAL = 'numerical';

export type LINEAR = 'linear';
export const LINEAR: LINEAR = 'linear';

export type CATEGORICAL = 'categorical';
export const CATEGORICAL: CATEGORICAL = 'categorical';

export type TIME = 'time';
export const TIME: TIME = 'time';

export type LOG = 'log';
export const LOG: LOG = 'log';

export type XYAxisTypeTime = TIME;
export const XYAxisTypeTime: XYAxisTypeTime = TIME;

export type XYAxisTypeCategorical = CATEGORICAL;
export const XYAxisTypeCategorical: XYAxisTypeCategorical = CATEGORICAL;

export type XYAxisTypeLinear = `${NUMERICAL}.${LINEAR}`;
export const XYAxisTypeLinear: XYAxisTypeLinear = `${NUMERICAL}.${LINEAR}`;

export type XYAxisTypeLog = `${NUMERICAL}.${LOG}`;
export const XYAxisTypeLog: XYAxisTypeLog = `${NUMERICAL}.${LOG}`;

export type XYAxisAnyNumericalType =
  | XYAxisTypeTime
  | XYAxisTypeLinear
  | XYAxisTypeLog;

export const XYAxisMapper = {
  [NUMERICAL_SCALE_TYPE]: XYAxisTypeLinear,
  [LOG_SCALE_TYPE]: XYAxisTypeLog,
  [CATEGORICAL_SCALE_TYPE]: XYAxisTypeCategorical,
  [TIME_SCALE_TYPE]: XYAxisTypeTime,
} as const;

export type XYAxisInternalTypes =
  (typeof XYAxisMapper)[keyof typeof XYAxisMapper];
